export default __webpack_public_path__ + "static/media/lucidagrande.e3a5361b.ttf";